import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { Button, Field, Input, Modal } from '@/components/ui';
import { ApiError } from '@/lib/api/client';
import { useAuthStore } from '@/stores/auth.store';
import { toast } from '@/stores/toast.store';
import { authApi } from './api';

const schema = z
  .object({
    currentPassword: z.string().min(1, 'مطلوب'),
    newPassword: z.string().min(8, '8 أحرف على الأقل').regex(/\d/, 'يجب أن تحتوي على رقم'),
    confirm: z.string(),
  })
  .refine((v) => v.newPassword === v.confirm, { path: ['confirm'], message: 'كلمتا المرور غير متطابقتين' });
type Values = z.infer<typeof schema>;

export function ChangePasswordDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const form = useForm<Values>({ resolver: zodResolver(schema) });
  const setAccessToken = useAuthStore((s) => s.setAccessToken);
  const mutation = useMutation({
    mutationFn: (v: Values) => authApi.changePassword(v.currentPassword, v.newPassword),
    meta: { silent: true },
    onSuccess: ({ accessToken }) => {
      setAccessToken(accessToken);
      toast.success('تم تغيير كلمة المرور وتسجيل الخروج من الأجهزة الأخرى');
      form.reset();
      onClose();
    },
  });
  const e = form.formState.errors;
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="تغيير كلمة المرور"
      size="sm"
      footer={
        <>
          <Button onClick={onClose}>إلغاء</Button>
          <Button variant="primary" loading={mutation.isPending} onClick={form.handleSubmit((v) => mutation.mutate(v))}>
            حفظ
          </Button>
        </>
      }
    >
      <div className="space-y-3">
        {mutation.error instanceof ApiError && <p className="rounded-lg bg-danger-50 p-2.5 text-xs text-danger">{mutation.error.message}</p>}
        <Field label="كلمة المرور الحالية" error={e.currentPassword?.message}>
          <Input type="password" dir="ltr" {...form.register('currentPassword')} />
        </Field>
        <Field label="كلمة المرور الجديدة" error={e.newPassword?.message}>
          <Input type="password" dir="ltr" {...form.register('newPassword')} />
        </Field>
        <Field label="تأكيد كلمة المرور" error={e.confirm?.message}>
          <Input type="password" dir="ltr" {...form.register('confirm')} />
        </Field>
      </div>
    </Modal>
  );
}
